<template>
  <button id="test">getAuthCode</button>
</template>

<script>
import { onMounted } from 'vue';

export default {
   setup() {
      onMounted(() => {
         const testButton = document.querySelector('#test');
         testButton.addEventListener('click', async () => {
            const res = await ap.getAuthCode({
               appId: '${2021005115622171}',
               scopes: ['auth_user']
            });
            ap.alert(JSON.stringify(res));
         });
      });

      return {};
   }
}
</script>